<template>
  <v-list id="js-nav-menu-list" :dense="false">
    <v-list-item
      @click="
        $router.push({ name: 'dashboardMentee', params: { id: getUserId() } })
      "
    >
      <v-list-item-icon>
        <v-icon>mdi-home</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <span>Home</span>
      </v-list-item-content>
    </v-list-item>

    <v-list-item @click="$router.push({ name: 'coursesGridMember' })">
      <v-list-item-icon>
        <v-icon>mdi-school</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <span>Learning Resources</span>
      </v-list-item-content>
    </v-list-item>

    <v-list-item @click="$router.push({ name: 'assessments' })">
      <v-list-item-icon>
        <v-icon>mdi-certificate-outline</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <span>Assessments</span>
      </v-list-item-content>
    </v-list-item>

    <v-list-item @click="$router.push({ name: 'documentsListMember' })">
      <v-list-item-icon>
        <v-icon>mdi-text-box-outline</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <span>Documents</span>
      </v-list-item-content>
    </v-list-item>

    <v-list-item @click="$router.push({ name: 'tools' })">
      <v-list-item-icon>
        <v-icon>mdi-tools</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <span>Tools</span>
      </v-list-item-content>
    </v-list-item>

    <v-list-item @click="$router.push({ name: 'user' })">
      <v-list-item-icon>
        <v-icon>mdi-account</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <span>Profile</span>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import userMixin from "@/mixins/userMixin"
export default {
  mixins: [userMixin]
}
</script>
